export const ARTICLE = 'ARTICLE';
export const ARTICLE_GROUP_CONTAINER = 'ARTICLE_GROUP_CONTAINER';
export const CONTENT = "CONTENT";



/** WEBPACK FOOTER **
 ** ./src/constants/ItemTypes.js
 **/